// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Description-module--cls1--1tPF7","cls2":"styles-Description-module--cls2--3rtEH styles-Description-module--cls1--1tPF7"};